/* RESPTAC theme JS — vanilla, no dependencies. */
(function () {
  'use strict';

  /* ---------- cart badge ---------- */

  function setCartCount(n) {
    var el = document.getElementById('rt-cart-count');
    if (el) el.textContent = String(n);
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCartCount(cart.item_count); })
      .catch(function () { /* leave server-rendered count */ });
  }

  /* ---------- product card quick-add ---------- */

  function bindQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-add-variant]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.getAttribute('data-add-variant')), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCartCount(); })
        .catch(function () { /* no-op */ })
        .then(function () { btn.disabled = false; });
    });
  }

  /* ---------- PDP: sliding gallery + zoom lightbox ---------- */

  var THUMB_ACTIVE = ['border-primary'];
  var THUMB_IDLE = ['border-neutral-200', 'hover:border-neutral-400'];
  var rtActiveSlide = 0;

  function slideCount() {
    var track = document.getElementById('rt-track');
    return track ? track.children.length : 0;
  }

  function goToSlide(i) {
    var track = document.getElementById('rt-track');
    if (!track) return;
    var n = slideCount();
    if (n === 0) return;
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    rtActiveSlide = i;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    var thumbs = document.querySelectorAll('[data-slide-index]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].classList.remove.apply(thumbs[t].classList, THUMB_ACTIVE.concat(THUMB_IDLE));
      var cls = (Number(thumbs[t].getAttribute('data-slide-index')) === i) ? THUMB_ACTIVE : THUMB_IDLE;
      thumbs[t].classList.add.apply(thumbs[t].classList, cls);
    }
  }

  function bindGallery() {
    var gallery = document.getElementById('rt-gallery');
    if (!gallery) return;

    document.addEventListener('click', function (e) {
      var thumb = e.target && e.target.closest ? e.target.closest('[data-slide-index]') : null;
      if (thumb) {
        e.preventDefault();
        goToSlide(Number(thumb.getAttribute('data-slide-index')));
      }
    });

    // swipe
    var startX = null, startY = null;
    gallery.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null; startY = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        goToSlide(rtActiveSlide + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    goToSlide(0);
  }

  function openLightbox() {
    var lb = document.getElementById('rt-lightbox');
    var img = document.getElementById('rt-lightbox-img');
    var scroller = document.getElementById('rt-lightbox-scroll');
    if (!lb || !img || !scroller) return;
    var slides = document.querySelectorAll('[data-slide-img]');
    var active = slides[rtActiveSlide] || slides[0];
    if (!active) return;
    img.src = active.getAttribute('data-zoom-src') || active.src;
    lb.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    img.onload = function () {
      scroller.scrollLeft = Math.max(0, (img.offsetWidth - scroller.clientWidth) / 2);
      scroller.scrollTop = Math.max(0, (img.offsetHeight - scroller.clientHeight) / 3);
    };
  }

  function closeLightbox() {
    var lb = document.getElementById('rt-lightbox');
    if (!lb) return;
    lb.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function bindLightbox() {
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest) {
        if (e.target.closest('[data-slide-img]') || e.target.closest('#rt-zoom-btn')) { openLightbox(); return; }
        if (e.target.closest('#rt-lightbox-close')) { closeLightbox(); return; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
      var lb = document.getElementById('rt-lightbox');
      if (lb && lb.hasAttribute('hidden')) {
        if (e.key === 'ArrowRight') goToSlide(rtActiveSlide + 1);
        if (e.key === 'ArrowLeft') goToSlide(rtActiveSlide - 1);
      }
    });
    // drag-to-pan
    var scroller = document.getElementById('rt-lightbox-scroll');
    if (!scroller) return;
    var dragging = false, lastX = 0, lastY = 0;
    scroller.addEventListener('mousedown', function (e) {
      dragging = true; lastX = e.clientX; lastY = e.clientY;
      scroller.classList.add('rt-grabbing'); e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      scroller.scrollLeft -= (e.clientX - lastX);
      scroller.scrollTop -= (e.clientY - lastY);
      lastX = e.clientX; lastY = e.clientY;
    });
    document.addEventListener('mouseup', function () {
      dragging = false; scroller.classList.remove('rt-grabbing');
    });
  }

  /* ---------- PDP: accordions ---------- */

  function bindAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-accordion-toggle]') : null;
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var icon = btn.querySelector('[data-accordion-icon]');
      var isOpen = !panel.hasAttribute('hidden');
      if (isOpen) {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        if (icon) icon.textContent = '+';
      } else {
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        if (icon) icon.textContent = '−';
      }
    });
  }

  /* ---------- PDP: variant option pills ---------- */

  var PILL_SELECTED = 'border-black bg-black text-white';
  var PILL_AVAILABLE = 'border-neutral-300 bg-white text-neutral-900 hover:border-[#574CD5] hover:text-[#574CD5]';
  var PILL_UNAVAILABLE = 'border-neutral-200 bg-neutral-50 text-neutral-400';
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];

  function initVariantPills() {
    var dataEl = document.getElementById('rt-variants');
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-option-group]'));
    if (!dataEl || groups.length === 0) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    groups.sort(function (a, b) {
      return Number(a.getAttribute('data-option-group')) - Number(b.getAttribute('data-option-group'));
    });

    function pillsOf(group) {
      return Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));
    }

    // Size ordering: XXS -> 5XL, as in the live PDP component.
    groups.forEach(function (group) {
      if (group.getAttribute('data-option-is-size') !== 'true') return;
      pillsOf(group)
        .sort(function (a, b) {
          var ia = SIZE_ORDER.indexOf(a.getAttribute('data-option-value').toUpperCase().trim());
          var ib = SIZE_ORDER.indexOf(b.getAttribute('data-option-value').toUpperCase().trim());
          return ia - ib;
        })
        .forEach(function (pill) { group.appendChild(pill); });
    });

    function selectedValues() {
      return groups.map(function (group) {
        var sel = group.querySelector('[data-selected="true"]');
        return sel ? sel.getAttribute('data-option-value') : null;
      });
    }

    function apply() {
      var sel = selectedValues();
      var match = null;
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var i = 0; i < variants[v].options.length; i++) {
          if (sel[i] !== variants[v].options[i]) { ok = false; break; }
        }
        if (ok) { match = variants[v]; break; }
      }

      groups.forEach(function (group, gi) {
        pillsOf(group).forEach(function (pill) {
          var value = pill.getAttribute('data-option-value');
          var isSel = sel[gi] === value;
          var avail = variants.some(function (variant) {
            if (!variant.available) return false;
            return variant.options.every(function (optVal, oi) {
              if (oi === gi) return optVal === value;
              return !sel[oi] || sel[oi] === optVal;
            });
          });
          if (pill.getAttribute('data-swatch') === 'true') {
            var sw = 'h-10 w-10 border-2 transition ';
            sw += isSel ? 'border-black' : (avail ? 'border-neutral-300 hover:border-neutral-500' : 'border-neutral-200 opacity-40');
            pill.className = sw;
          } else {
            var state = isSel ? PILL_SELECTED : (avail ? PILL_AVAILABLE : PILL_UNAVAILABLE);
            pill.className = pill.getAttribute('data-base-class') + ' ' + state;
            var span = pill.querySelector('span');
            if (span) span.className = (!avail && !isSel) ? 'line-through opacity-50' : '';
          }
        });
        var label = document.querySelector('[data-option-label="' + gi + '"]');
        if (label) label.textContent = sel[gi] || label.getAttribute('data-empty-label') || '';
      });

      var idInput = document.getElementById('rt-variant-id');
      var addBtn = document.getElementById('rt-add-button');
      var addLabel = document.getElementById('rt-add-label');
      var addIcon = document.getElementById('rt-add-icon');
      var price = document.getElementById('rt-price');
      var dynamicCheckout = document.getElementById('rt-dynamic-checkout');
      if (match) {
        if (idInput) idInput.value = String(match.id);
        if (price) price.textContent = match.price;
        if (addBtn) addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? 'Add to Cart' : 'Out of Stock';
        if (addIcon) addIcon.style.display = match.available ? '' : 'none';
        if (dynamicCheckout) dynamicCheckout.hidden = !match.available;
      } else {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        var needsSize = groups.some(function (group) {
          return group.getAttribute('data-option-is-size') === 'true' && !group.querySelector('[data-selected="true"]');
        });
        if (addLabel) addLabel.textContent = needsSize ? 'Select Size' : 'Select options';
        if (addIcon) addIcon.style.display = 'none';
        if (dynamicCheckout) dynamicCheckout.hidden = true;
      }
    }

    groups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target && e.target.closest ? e.target.closest('[data-option-value]') : null;
        if (!pill || !group.contains(pill)) return;
        e.preventDefault();
        pillsOf(group).forEach(function (p) {
          var selected = p === pill;
          p.setAttribute('data-selected', selected ? 'true' : 'false');
          p.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        apply();
      });
    });

    apply();
  }

  function init() {
    refreshCartCount();
    bindQuickAdd();
    bindGallery();
    bindLightbox();
    bindAccordions();
    initVariantPills();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
